import { useMixPanelContext } from '../context';

export function useMixpanel<T extends string>() {
  const { mixpanel } = useMixPanelContext();

  const track = (event: T, config: Record<string, any>) => {
    mixpanel?.track(event, config);
  };

  // TODO Also return pageview function

  return { track };
}
